import { showDialog } from '../reducers/app';
import { setEditOutletDialog } from '../reducers/edit_outlet_dialog';
import { unique_value } from '../util/unique';
export function editOutlet(id) {
    return (dispatch, getState) => {
        const { definitions } = getState();
        const outlet = definitions.outlets[id];
        if (outlet == undefined) {
            return;
        }
        const editOutlet = {
            id: outlet.id,
            title: outlet.title,
            kind: outlet.kind,
            codes: outlet.codes.map(v => ({ code: v.code, unit: v.unit, key: unique_value() })),
            comment: outlet.comment
        };
        dispatch(setEditOutletDialog(editOutlet));
        dispatch(showDialog('outlet-edit'));
    };
}
